import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/graphql';

const MAIN_LINE_ITEM_INDEX = 0;
const mapContactLensesSubscriptionLineItem = ({ bundleLineItems , quantity , typeDetails  })=>{
    if (!bundleLineItems.every((item)=>Boolean(item.ratePlanId)
    )) {
        console.error(`All of the bundleLineItems must have a ratePlanId defined.`);
        return null;
    }
    var _quantity;
    return {
        sku: bundleLineItems[MAIN_LINE_ITEM_INDEX].sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: Types.LineItemType.BUNDLE,
        bundleLineItemsType: Types.BundleLineItemType.CONTACT_LENSES_SUBSCRIPTION,
        bundleLineItems: bundleLineItems.map((item, index)=>swcHelpers.objectSpread({}, item, {
                type: Types.BundleLineItemProductType[item.type.toUpperCase()],
                quantity: (_quantity = item.quantity) !== null && _quantity !== void 0 ? _quantity : 1,
                isMainBundleLineItem: index === MAIN_LINE_ITEM_INDEX
            })
        ),
        typeDetails: swcHelpers.objectSpread({}, typeDetails, {
            billingFrequency: Types.BillingFrequency[typeDetails.billingFrequency.toUpperCase()],
            deliveryFrequency: Types.DeliveryFrequency[typeDetails.deliveryFrequency.toUpperCase()]
        })
    };
};

export { mapContactLensesSubscriptionLineItem };
//# sourceMappingURL=contact-lenses-subscription.js.map
